export const UPDATE_CHECK_PERIOD = 60 * 60 * 1000; // 1 hour
export const VAPID_KEY = 'BCKBn0gYGx9xxLfUGLc4U8yVg9b7fe1_ridQ_TlxX_Euylk6g2qIynGyY5aKoz540xFHSZGm66MAGBwkGyQ4TiA';
